// Number of rows fetched and displayed per page on all list screens.
export const LIST_PAGE_SIZE = 10;
